/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="app.common.filters.module.ts" />

module App.Common.Filters {
	'use strict';

	function filter(input: Hca.HiLO.ViewModel.IAddressViewModel, nonHtml: boolean): string {
		if (!input) {
			return '';
		}

		var addressLines = [
			input.line1,
			input.line2,
			input.line3,
			input.line4,
			input.townOrCity,
			input.county,
			input.postcode
		];

		return _.compact(addressLines).join(nonHtml ? '\n' : '<br/>');
	}

	angular
		.module('app.common.filters')
		.filter('multilineAddress', [() => { return filter; }]);
}